/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gray_Dusty_Dove_HowlInputs */

const en_gray_dusty_dove_howl = /** @type {(inputs: Gray_Dusty_Dove_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historic Results`)
};

const de_gray_dusty_dove_howl = /** @type {(inputs: Gray_Dusty_Dove_HowlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historische Ergebnisse`)
};

/**
* | output |
* | --- |
* | "Historic Results" |
*
* @param {Gray_Dusty_Dove_HowlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const gray_dusty_dove_howl = /** @type {((inputs?: Gray_Dusty_Dove_HowlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gray_Dusty_Dove_HowlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gray_dusty_dove_howl(inputs)
	return de_gray_dusty_dove_howl(inputs)
});